/** Shared by paginator keyboard code (registry + directives). */

export function isActiveElementInsideCdkOverlay(): boolean {
  return !!document.activeElement?.closest?.('.cdk-overlay-container');
}

/**
 * Skip paginator shortcuts only while a CDK overlay has focus (e.g. rows-per-page listbox open).
 * Do **not** skip when focus is only on the closed `mat-select` trigger — otherwise Ctrl+Arrow
 * is left to Material and cycles page size instead of changing page index.
 */
export function shouldIgnorePaginatorDocumentShortcut(
  _paginatorEl: HTMLElement
): boolean {
  return isActiveElementInsideCdkOverlay();
}
